import { render, staticRenderFns } from "./RegulationQuestionsSection.vue?vue&type=template&id=431dc7d6&"
import script from "./RegulationQuestionsSection.vue?vue&type=script&lang=js&"
export * from "./RegulationQuestionsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports